// utils/cropImage.js

/**
 * Utility to create an HTMLImageElement from a given URL
 */
const createImage = (url) =>
  new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = "anonymous"; // Important for canvas use
    img.onload = () => resolve(img);
    img.onerror = (error) => reject(new Error("Failed to load image"));
    img.src = url; // Set src after onload/onerror
  });

/**
 * Crops an image using canvas and returns a blob URL
 * @param {string} imageSrc - The image source (base64 or URL)
 * @param {Object} crop - The cropped area { x, y, width, height }
 * @returns {Promise<string>} - A blob URL of the cropped image
 */
export const getCroppedImg = async (imageSrc, crop) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");

  if (!ctx) {
    throw new Error("Canvas context is not available");
  }
  canvas.width = crop.width;
  canvas.height = crop.height;

  ctx.drawImage(
    image,
    crop.x, crop.y, crop.width, crop.height,
    0, 0, crop.width, crop.height
  );

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (!blob) {
        reject(new Error("Canvas is empty or toBlob failed"));
        return;
      }
      const file = new File([blob], "cropped-image.jpg", { type: "image/jpeg" });
      resolve(file);
    }, "image/jpeg");
  });
};